// extracted by mini-css-extract-plugin
module.exports = {"deliveryDiffers":"kassa_deliveryDiffers__2JFcZ","loading":"kassa_loading__BXt4D","active":"kassa_active__9E_ji","ldsHeart":"kassa_ldsHeart__If6YY"};